import { Loading } from "@/components/shared/icons";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

export const Spin = ({
  className,
}: {
  size?: number; // unused?
  className?: string;
}) => (
  <View className="flex items-center justify-center">
    <Loading className={cn("animate-spin", className)} />
  </View>
);
